import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import { NavParams, ToastController, ViewController } from "ionic-angular";
import { Subscription } from "rxjs/Subscription";
import { ClientData } from "../../../../../../providers/client";
import { GenFormBuilder } from "../../../../../../providers/form";
import { Utilities } from "../../../../../../providers/utilities";
import { IClient } from "../../../../../../shared/models/client.model";
import { IProfileUsers } from "../../../../../../shared/models/profile-users.model";
import * as sharedSelectors from "../../../../../../shared/reducers/shared.reducer";

@Component({
  selector: "app-profile-users-form",
  templateUrl: "profile-users-form.component.html",
})

export class ProfileUsersFormComponent implements OnInit, OnDestroy {

  public form: FormGroup;

  public submitAttempt: boolean = false;

  public clientId: string;

  public modules: string[] = this.utilities.defaultModulesProfileUsers;

  public client: IClient;

  public clientSubscribe: Subscription;

  public profile: IProfileUsers;

  public defaultLanguage: string;

  public language: string;

  public languageMenu: "en" | "es" = "es";

  constructor(
    private formBuilder: FormBuilder,
    private genForm: GenFormBuilder,
    private utilities: Utilities,
    private clientData: ClientData,
    private toastController: ToastController,
    public viewCtrl: ViewController,
    private store: Store<{}>,
    private navParams: NavParams,
  ) { }

  public ngOnInit() {
    this.clientId = this.navParams.get("clientId");
    this.profile = this.navParams.get("profile");
    this.clientSubscribe = this.store.select(sharedSelectors.getClient).subscribe((client) => {
      if (client) {
        this.client = client;
        this.defaultLanguage = client.defaultLanguage;
        this.language = this.defaultLanguage;
        this.buildForm();
      }
    });
  }

  public onFormSubmitted({ value, valid }: { value: any; valid: boolean }) {
    this.submitAttempt = true;
    if (valid) {
      const load = this.utilities.setLoading();
      this.clientData.createProfileUsers(this.clientId, value)
        .then(() => {
          this.toastController.create({
            duration: 3000,
            message: "The profile was succesfully update",
          }).present();

          this.viewCtrl.dismiss().then(() => load.dismiss());
      });
    }
  }

  public ngOnDestroy() {
    if (this.clientSubscribe) { this.clientSubscribe.unsubscribe(); }
  }

  private buildForm() {
    this.form = this.formBuilder.group({});
    this.genForm.genInputString("id", this.form);
    this.genForm.genInputString("name", this.form, true);
    this.genForm.genInputJSON("modules", this.form, true);
    this.genForm.genToggle("is_menu", this.form);
    this.genForm.genToggle("state", this.form);
    this.patchForm();
  }

  private patchForm() {
    if (this.profile) {
      this.form.patchValue(this.profile);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/interactivity/pages/profiles-users/components/profile-users-form/profile-users-form.component.ts